import i18n from 'i18n';
import { IClaim } from 'types/income';
import { converters as tableConverters } from 'store/table';
import { converters as filesConverters } from 'store/files';
import { RECOGNITION_SHOP_ID } from 'store/recognitions';
import { loaders } from './claims.loaders';
import { Claim } from './claims.types';
import { COMPANY_EXPENSE_ID } from './claims.constants';

const convertClaim = (claim: IClaim): Claim => {
  return {
    id: claim.id,
    status: claim.status,
    type: claim.type,
    sources:
      claim.sources
        ?.filter((source) =>
          source.type === 'benefit' && !source.benefit ? false : true,
        )
        .map((source) => ({
          id:
            source.type === 'recognition'
              ? RECOGNITION_SHOP_ID
              : source.type === 'companyExpense'
              ? COMPANY_EXPENSE_ID
              : source.benefit.id,
          name:
            source.type === 'recognition'
              ? i18n.t('wallet.employeeWalletFundsSourceRecognition')
              : source.type === 'companyExpense'
              ? i18n.t('claims.companyExpense.label')
              : source.benefit.name,
        })) ?? [],
    admin: {
      id: claim.adminId,
      email: claim.adminEmail,
      fullName: claim.adminName,
    },
    supplier: claim.employeeComment,
    adminComment: claim.adminComment,
    requestedAmount: claim.requestedAmount,
    employee: claim.employeeId
      ? {
          id: claim.employeeId ?? '',
          firstName: claim.employeeFirstName ?? '',
          lastName: claim.employeeLastName ?? '',
          fullName: [claim.employeeFirstName, claim.employeeLastName]
            .filter(Boolean)
            .join(' '),
        }
      : null,
    files: filesConverters.getUploadedFiles(claim.files ?? []),
    purchasedAt: claim.purchaseDate,
    claimedAt: claim.claimDate,
    createdAt: claim.createdAt,
    updatedAt: claim.updatedAt,
  };
};

const convertClaims = (claims: IClaim[]): Claim[] => {
  return claims.map(convertClaim);
};

export const converters = {
  getClaims: ({ data }: Awaited<ReturnType<typeof loaders.getClaims>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertClaims(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getClaim: ({ data }: Awaited<ReturnType<typeof loaders.getClaim>>) => {
    return convertClaim(data);
  },
};
